import type { RouteLocationNormalized } from 'vue-router'

import type { TrackingConfig } from '../../types'

/**
 * Returns the route name to use for web vitals tracking.
 * If the route is not allowed, returns 'other'.
 * If the route has an override, returns the override.
 * Otherwise, returns the route name.
 */
export function getWebVitalsRouteName(
  route: RouteLocationNormalized,
  config: TrackingConfig['webVitals'],
) {
  const routeName = route.name?.toString()
  if (!routeName) return 'other'

  const isAllowed =
    config.allowedRouteNames.includes(routeName) ||
    config.dangerouslyMonitorAllPages

  if (!isAllowed) return 'other'

  const override = config.routeNameOverrides?.[routeName]

  if (!override) return routeName

  return override
}
